import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box } from 'components/ui';
import FeaturedBenefitsSection from 'components/Content/BeautyInsider/BeautyInsiderBenefits/FeaturedBenefitsSection';
import NextTierBenefitsSection from 'components/Content/BeautyInsider/BeautyInsiderBenefits/NextTierBenefitsSection';
import getBenefitsViewState from 'components/Content/BeautyInsider/BeautyInsiderBenefits/benefitsViewState';

/**
 * Renders the Benefits tab sections owned by the BIHub_FeaturedBenefits Contentful placeholder.
 */
const BeautyInsiderBenefits = props => {
    const state = getBenefitsViewState(props);
    const featuredBenefits = state.featuredBenefits || props.featuredBenefits;
    const nextTierBenefits = state.nextTier;
    const viewAllBenefitsModal = props?.items?.[0]?.action;

    if (!featuredBenefits && !nextTierBenefits) {
        return null;
    }

    return (
        <Box data-at={Sephora.debug.dataAt('bi_benefits')}>
            <FeaturedBenefitsSection
                section={featuredBenefits}
                viewAllBenefitsModal={viewAllBenefitsModal}
            />
            <NextTierBenefitsSection state={state} />
        </Box>
    );
};

export default wrapFunctionalComponent(BeautyInsiderBenefits, 'BeautyInsiderBenefits');
